import {GrowthBook, useGrowthBook} from "@growthbook/growthbook-react";

import {usePublishAnalyticsEvent} from "@repo/analytics-learning-time";
import {useUserAttributes} from "@repo/shared-core";

import {canUserParticipateInABTesting} from "./can-user-participate-in-ab-testing.ts";
import type {GrowthBookForABTest} from "./growthbook-for-ab-test.ts";

export const useGrowthBookForABTest = () => {
    const growthBook: GrowthBookForABTest | undefined = useGrowthBook() as any;
    const publishAnalyticsEvent = usePublishAnalyticsEvent();
    const userAttributes = useUserAttributes();

    if (!growthBook) {
        return growthBook;
    }

    const getFeatureValue = GrowthBook.prototype.getFeatureValue;

    growthBook.getFeatureValueAndEnrollInABTest = (
        featureKey: string,
        fallback: any,
    ) => {
        // The status of whether a user can participate in an A/B test can change
        // over time. If a user was previously enrolled in an A/B test and then
        // opted out we want to be able to remove that user from our metrics for
        // that test. This code will fire an analytics even whenever we try to
        // enroll a user in an A/B test who's opted out. `getGrowthbook()` prevents
        // users who have opted out from seeing alternatives by setting `enabled` to
        // `false` when initialize the Growthbook SDK. This disables all experiments.
        if (!canUserParticipateInABTesting(userAttributes)) {
            const features = globalThis.__GROWTHBOOK_FEATURES__?.features ?? {};
            const rules = features[featureKey]?.rules ?? [];

            for (const rule of rules) {
                if ("variations" in rule && rule.key) {
                    publishAnalyticsEvent({
                        eventType:
                            "ExperimentationPlatResearchIneligibleDetected",
                        eventSchemaVersion: 1,
                        experimentId: rule.key,
                    });
                }
            }
        }

        return getFeatureValue.call(growthBook, featureKey, fallback); // ?
    };

    return growthBook;
};
